import createSagaMiddleware from "redux-saga";
import { carMiddlewares, carReducers } from "@apac/cars";
import { flightsPriceFreezeRootReducer } from "@apac/components/flights-price-freeze";
import { disruptionRootReducer } from "@b2bportal/core-disruption";
import {
  flightRtkQueryReducers,
  flightsPostBookingApi,
  flightsRootReducer,
} from "@b2bportal/core-flights";
import { hotelMiddlewares, hotelReducers } from "@b2bportal/core-hotels";
import { tripsRootReducer } from "@b2bportal/core-trips";
import { authReducer } from "@hopper-b2b/self-serve";
import {
  configureStore,
  combineSlices,
  createDynamicMiddleware,
} from "@reduxjs/toolkit";
import {
  tenantFlightsMiddleware,
  tenantFlightsReducers,
} from "./tenantFlights";
import { travelerReducers, travelerMiddleware } from "./travelerStore";

const sagaMiddleware = createSagaMiddleware();
const middleware = [
  sagaMiddleware,
  ...tenantFlightsMiddleware,
  ...hotelMiddlewares,
  ...carMiddlewares,
  ...travelerMiddleware,
  flightsPostBookingApi.middleware,
];

export const dynamicMiddleware = createDynamicMiddleware();

export const reducer = combineSlices({
  disruption: disruptionRootReducer,
  auth: authReducer,
  flights: flightsRootReducer,
  trips: tripsRootReducer,
  ...hotelReducers,
  ...tenantFlightsReducers,
  ...travelerReducers,
  ...carReducers,
  ...flightRtkQueryReducers,
  flightsPriceFreeze: flightsPriceFreezeRootReducer,
});

const coreStore = configureStore({
  reducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
      .concat(middleware)
      .concat(dynamicMiddleware.middleware),
});

// const rootSaga = {}
// // Run the root saga after creating the store
// sagaMiddleware.run(rootSaga);

export type AppDispatch = typeof coreStore.dispatch;
export type RootState = ReturnType<typeof coreStore.getState>;
export default coreStore;
